
<div
  :class="
    classes(
      n(),
      n(`--${state.type}`),
      n(`--${state.background}`),
      n(`--${state.size}`),
      [isLiteapp, n('--liteapp')],
    )
  "
  :style="tabsStyle"
>
  <!-- 标签栏区域 -->
  <div
    :class="
      classes(
        n('nav-wrapper'),
        [state.showGradient && showLeftGradient, n('nav-wrapper--gradient-left')],
        [state.showGradient && showRightGradient, n('nav-wrapper--gradient-right')],
      )
    "
  >
    <!-- 左侧插槽 -->
    <div
      v-if="$slots['nav-left']"
      :class="n('nav-left')"
    >
      <slot
        name="nav-left"
        :active-index="activeIndex"
      />
    </div>

    <!-- LiteApp：遮罩作用在普通 div 容器 nav-mask 上（mask 加在普通 DOM 可正常重绘），
         绝不可加在 scroll-view 原生组件上（动态切换不重绘、残留旧遮罩）。无颜色、真·边缘淡出。 -->
    <div
      v-if="isLiteapp"
      ref="navMaskRef"
      :class="n('nav-mask')"
    >
      <scroll-view
        ref="tabsNavRef"
        :class="n('nav')"
        scroll-x
        :scroll-left="scrollLeft"
        :scroll-with-animation="scrollWithAnimation"
        :show-scrollbar="false"
        scroll-config="clamping"
        @scroll="handleScrollViewScroll"
        @scrollend="handleScrollViewScrollEnd"
      >
        <div
          :class="classes(n('nav-track'), [props.align === 'center', n('nav-track--center')])"
          :style="navTrackStyle"
        >
          <slot />
          <!-- 底部指示器 (仅 normal 类型) -->
          <div
            v-if="state.type === 'normal'"
            ref="indicatorRef"
            :class="n('indicator')"
            :style="indicatorStyle"
          />
        </div>
      </scroll-view>
    </div>

    <!-- 标签栏 - H5 环境使用原生 div -->
    <div
      v-else
      ref="tabsNavRef"
      :class="n('nav')"
      @scroll="handleScroll"
    >
      <div
        :class="classes(n('nav-track'), [props.align === 'center', n('nav-track--center')])"
        :style="navTrackStyle"
      >
        <slot />
        <!-- 底部指示器 (仅 normal 类型) -->
        <div
          v-if="state.type === 'normal'"
          ref="indicatorRef"
          :class="n('indicator')"
          :style="indicatorStyle"
        />
      </div>
    </div>

    <!-- 右侧插槽 -->
    <div
      v-if="$slots['nav-right']"
      :class="n('nav-right')"
    >
      <slot
        name="nav-right"
        :active-index="activeIndex"
      />
    </div>
  </div>

  <!-- 内容区域 -->
  <div
    v-if="state.swipeable"
    :class="n('content')"
  >
    <div
      :class="n('content-track')"
      :style="{
        transform: `translateX(-${activeIndexNum * 100}%)`,
        transition: state.animated ? `transform ${state.duration}ms ease` : 'none',
      }"
    >
      <slot name="content" />
    </div>
  </div>
</div>
